var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-2"},_vm._l((_vm.error),function(e,key){return _c('p',{key:key,staticClass:"error mb-1"},[_vm._v(_vm._s(e))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }